/** Issuer hasn't whitelisted the VaultBundlesV1 contract for the vault asset. */
export const BUNDLE_NOT_AUTHORIZED_MESSAGE =
  "The issuer hasn't authorized deposits to this vault through the Morpho app yet. Contact the issuer to enable it."

/** Issuer hasn't whitelisted VaultBundlesV1 for withdrawals routed through it. */
export const WITHDRAW_BUNDLE_NOT_AUTHORIZED_MESSAGE =
  "The issuer hasn't authorized withdrawals from this vault through the Morpho app yet. Contact the issuer to enable it."

/** Same issuer gate on a market (BlueBundlesV1) flow. */
export const MARKET_BUNDLE_NOT_AUTHORIZED_MESSAGE =
  "The issuer hasn't authorized this action through the Morpho app yet. Contact the issuer to enable it."

/** Issuer hasn't enabled the VaultExitBundlesV1 emergency-exit path for the vault asset. */
export const EXIT_BUNDLE_NOT_ENABLED_MESSAGE =
  "The issuer hasn't enabled emergency exits for this vault. If vault liquidity runs out, you may need to wait for it to return before you can withdraw."

/** No liquidity AND no issuer-enabled emergency exit — the withdraw is stuck. */
export const EXIT_BUNDLE_NO_LIQUIDITY_MESSAGE =
  "This vault has no available liquidity, and the issuer hasn't enabled emergency exits. You can't withdraw until liquidity returns."
